import React, {Fragment, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles, useTheme, withStyles} from '@mui/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {Checkbox, FormControlLabel, Grid, MenuItem} from "@mui/material";
import {requestApi} from "../../../utils/utils";
import NautilusTextInput from "../../Common/NautilusTextInput";
import {Link} from "react-router-dom";
import LoginForm from "./LoginForm";
import GuestFormTransaction from "./GuestFormTransaction";


const NautilusTabs = withStyles((theme) => ({
    root: {
        '& button': {
            textDecoration: 'none',
            backgroundColor: '#f2fbfe !important',
            textTransform: 'initial',
        },
    },
    indicator: {
        backgroundColor: '#1ebce7',
    },
}))(Tabs);
const NautilusTab = withStyles((theme) => ({

    root: {
        padding: 15,
        fontSize: '1.8rem',
        color: '#00b7f0',
        '&:hover': {
            color: '#0087bd',
            opacity: 1,
        },
        '&$selected': {
            color: '#0087bd',
            fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
            color: '#0087bd',
        },
    }
}))((props) => <Tab disableRipple {...props} />);

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                children
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#f2fbfe',
    },
    '& $selected': {
        color: '#1ebce7'
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'auto'
    },
    paper: {
        maxHeight: 800,
        overflow: 'auto',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function ContactForm({customer = [], setCustomer, tab, setTab, widget = false, guestWidget = [], setGuestWidget}) {
    const [source, setSource] = useState([]);
    const classes = useStyles();
    const theme = useTheme();
    const {dealer} = window;
    useEffect(() => {
        requestApi('/get-hdyh-options', 'GET', null, ({data}) => {
            if ('status' in data && data['status'] === 'success') {
                const sources = Object.keys(data['data']).map((option) => {
                    return {label: data['data'][option], value: option === "" ? 0 : option};
                });
                setSource(sources);
            }
        });

    }, []);

    const handleForm = (event) => {
        setCustomer({...customer, [event.target.name]: event.target.value});
    }
	const handleFormWidget = (event) => {
        setGuestWidget({...guestWidget, [event.target.name]: event.target.value});
    }
    const handleCheck = (event) => {
        setCustomer({...customer, [event.target.name]: event.target.checked});
    }

    const handleChange = (event, newValue) => {
        setTab(newValue);
    };
    return (
        <Fragment>
            <div className={classes.root} id="contactForm">
                {dealer && parseInt(dealer)=== 1 && widget === false ? <LoginForm handleForm={handleForm} customer={customer} classes={classes}/> :
                widget ? <GuestFormTransaction handleForm={handleFormWidget} customer={guestWidget} classes={classes}/> :
					<Fragment>
						<NautilusTabs
							value={tab}
							onChange={handleChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							aria-label="full width tabs example"
						>
							<NautilusTab label="This is your first trip with us!"  {...a11yProps(0)} />
							<NautilusTab label="You have traveled with us before" {...a11yProps(1)} />
						</NautilusTabs>
						<Grid container direction="row" alignItems="center" className={'formsInfo'}>
							<TabPanel value={tab} index={0} dir={theme.direction}>
								<form className={'contactForm'} noValidate autoComplete="off">
									<Grid container direction="row" justify="center" alignItems="center"
										style={{paddingTop: 30, paddingBottom: 30}}>
										<Grid item sm={6} xs={12} style={{padding: 10}}>
											<NautilusTextInput fullWidth name="firstname" value={customer['firstname']}
															onChange={handleForm} label="First Name" variant="outlined"/>
										</Grid>
										<Grid item sm={6} xs={12} style={{padding: 10}}>
											<NautilusTextInput fullWidth name="lastname" value={customer['lastname']}
															onChange={handleForm} label="Last Name" variant="outlined"/>
										</Grid>
										<Grid item sm={6} xs={12} style={{padding: 10}}>
											<NautilusTextInput fullWidth name="email" value={customer['email']}
															onChange={handleForm} label="Email" variant="outlined"/>
										</Grid>
										<Grid item sm={6} xs={12} style={{padding: 10}}>
											<NautilusTextInput fullWidth name="telephone" value={customer['telephone']}
															onChange={handleForm} label="Telephone" variant="outlined"/>
										</Grid>
										<Grid item sm={6} xs={12} style={{padding: 10}}>
											<NautilusTextInput fullWidth name="password" value={customer['password']}
															onChange={handleForm} type="password"
															autoComplete="current-password" label="Password"
															variant="outlined"/>
										</Grid>
										<Grid item sm={6} xs={12} style={{padding: 10}}>
											<NautilusTextInput fullWidth name="password_confirmation"
															value={customer['password_confirmation']} onChange={handleForm}
															type="password" autoComplete="current-password"
															label="Confirm Password" variant="outlined"/>
										</Grid>
										{source.length > 0 && <>
											<Grid item sm={6} xs={12} style={{padding: 10}}>
												<NautilusTextInput fullWidth name="howdidyouhear"
																value={customer['howdidyouhear']}
																variant="outlined" select label="How did you hear about us?"
																id="howdidyouhear"
																onChange={handleForm}>
													{source.map(option => (
														<MenuItem key={option.value} value={option.value}>
															{option.label}
														</MenuItem>
													))}
												</NautilusTextInput>
											</Grid>
											<Grid item sm={6} xs={12} style={{padding: 10}}>
												{customer['howdidyouhear'] === 'Other' &&
												<NautilusTextInput fullWidth name="howdidyouhearother"
																value={customer['howdidyouhearother']} onChange={handleForm}
																label="Other" variant="outlined"/>
												}
											</Grid>
										</>}
										<Grid item sm={12} xs={12} style={{padding: 10}}>
											<FormControlLabel
												control={
													<Checkbox checked={customer['newsletter']}
															onChange={handleCheck}
															name="newsletter"
															color="primary"
													/>
												}
												label="Please send me the latest news, special offers and promotional emails"/>
										</Grid>
									</Grid>
								</form>
							</TabPanel>
							<TabPanel value={tab} index={1} dir={theme.direction}>
								<LoginForm handleForm={handleForm} customer={customer} classes={classes}/>
							</TabPanel>
						</Grid>
					</Fragment>
				}
            </div>
        </Fragment>
    );
}
